exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswerBlock-module__answerblock___2zrM8{height:80px;width:300px;background-color:hsla(0,0%,100%,.4);border-radius:10px;display:flex;justify-content:center;align-items:center;transition:all .2s ease-in-out;color:#fff}.AnswerBlock-module__answerblock___2zrM8 .AnswerBlock-module__text___24Zsx{font-size:24px}.AnswerBlock-module__answerblock___2zrM8 .AnswerBlock-module__text___24Zsx strong{font-weight:600}.AnswerBlock-module__answerblock___2zrM8 .AnswerBlock-module__text___24Zsx del{opacity:.5}.AnswerBlock-module__answerblock___2zrM8 .AnswerBlock-module__play___3fcc-{font-size:35px}.AnswerBlock-module__answerblock___2zrM8.AnswerBlock-module__right___h7xvY{background-color:#3edc89}.AnswerBlock-module__answerblock___2zrM8.AnswerBlock-module__wrong___1lmYr{background-color:#f44e4e}", ""]);

// exports
exports.locals = {
	"answerblock": "AnswerBlock-module__answerblock___2zrM8",
	"text": "AnswerBlock-module__text___24Zsx",
	"play": "AnswerBlock-module__play___3fcc-",
	"right": "AnswerBlock-module__right___h7xvY",
	"wrong": "AnswerBlock-module__wrong___1lmYr"
};